<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageShell from '@/Components/UI/PageShell.vue'
import { Link } from '@inertiajs/vue3'

defineOptions({ layout: AppLayout })
defineProps({
  accounts: { type: Array, default: () => [] }
})
</script>

<template>
  <PageShell title="Portal accounts">
    <template #actions>
      <Link
        href="/admin/portal_accounts/new"
        class="inline-flex items-center px-3 py-2 font-medium text-sm no-underline"
        style="background: var(--accent); color: var(--accentInk); border-radius: var(--radius-button, 8px);"
      >
        + New portal account
      </Link>
    </template>

    <div class="overflow-x-auto" style="border-radius: var(--radius-table); border: 1px solid var(--line);">
      <table class="w-full border-collapse">
        <thead>
          <tr>
            <th class="acc-th">Owner</th>
            <th class="acc-th">Email</th>
            <th class="acc-th">Last sign-in</th>
            <th class="acc-th">Sign-ins</th>
            <th class="acc-th">Status</th>
            <th class="acc-th"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="a in accounts" :key="a.id" class="acc-row">
            <td class="acc-td">{{ a.owner_label }}</td>
            <td class="acc-td">{{ a.email }}</td>
            <td class="acc-td" style="color: var(--inkSoft);">{{ a.last_sign_in_at || '—' }}</td>
            <td class="acc-td" style="color: var(--inkSoft);">{{ a.sign_in_count }}</td>
            <td class="acc-td">
              <span :class="`pill pill--${a.status}`">{{ a.status }}</span>
            </td>
            <td class="acc-td text-right">
              <Link :href="`/admin/portal_accounts/${a.id}`" style="color: var(--accent); text-decoration: none;">
                View
              </Link>
            </td>
          </tr>
          <tr v-if="accounts.length === 0">
            <td colspan="6" style="padding: 2.5rem 1rem; text-align: center; color: var(--muted); font-size: 0.875rem;">
              No portal accounts yet.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </PageShell>
</template>

<style scoped>
.acc-th {
  padding: 0.75rem 1rem;
  text-align: left;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--muted);
  border-bottom: 1px solid var(--line);
}
.acc-row {
  border-bottom: 1px solid var(--line);
}
.acc-row:last-child {
  border-bottom: none;
}
.acc-row:hover {
  background: var(--surfaceAlt);
}
.acc-td {
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  color: var(--ink);
}
.pill {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 500;
}
.pill--active   { background: color-mix(in oklch, var(--ok) 16%, var(--surface)); color: var(--ok); }
.pill--disabled { background: color-mix(in oklch, var(--muted) 14%, var(--surface)); color: var(--muted); }
.pill--locked   { background: color-mix(in oklch, var(--warn) 14%, var(--surface)); color: var(--warn); }
</style>
